// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
    }
  }
}
